import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';


export default function ({ sendToMauticSegment, currentSegments, segmentList, onClickCheckBox, onChangeField }) {
	return (
		<React.Fragment>
			<FormControlLabel
				control={<Checkbox
					color="primary"
					checked={sendToMauticSegment}
					onChange={() => onClickCheckBox('sendToMauticSegment')}
					style={{ block: { maxWidth: 250 }, checkbox: { marginBottom: 16, } }}
				/>}
				label="Enviar para um segmento do Mautic"
			/>
			{sendToMauticSegment &&
				(
					<React.Fragment>
						<br />
						<Autocomplete
							multiple
							id="tags-standard"
							options={segmentList.map((option) => option.name)}
							filterSelectedOptions
							renderInput={(params) => (
								<TextField
									{...params}
									label="segmentos"
									margin="normal"
									variant="outlined"
									InputProps={{ ...params.InputProps, type: 'search' }}
								/>
							)}
							onChange={(event,value) => {
								onChangeField('currentSegments',value)
							}}
							value={currentSegments}
						/>

					</React.Fragment>
				)
			}
		</React.Fragment>
	);
}













// WEBPACK FOOTER //
// ./src/components/notification/fields/MauticSegmentField.js